import styled, { css } from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

export const TradingPositionListItemSkeleton: React.FC = () => {
  return (
    <Root>
      <IconContainer>
        <Skeleton width={32} height={32} variant="circular" />
      </IconContainer>
      <Main>
        <ColumnLeft
          css={css`
            gap: 2px;
          `}
        >
          <Skeleton width={100} height={12} />
          <Skeleton width={50} height={5} />
          <Skeleton width={40} height={5} />
        </ColumnLeft>
        <ColumnRight>
          <Skeleton width={40} height={5} />
          <Skeleton width={80} height={12} />
          <Skeleton width={40} height={5} />
        </ColumnRight>
      </Main>
      <MarketCap>
        <Skeleton width={40} height={5} />
        <Skeleton width={80} height={12} />
        <Skeleton width={40} height={5} />
      </MarketCap>
    </Root>
  )
}

const Root = styled.div`
  height: 60px;
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  align-items: center;
  overflow: hidden;

  border-radius: 12px;
  border: 1px solid var(--backgroundA-2);
  background: var(--background-2);

  padding: 11px 12px;

  &:active {
    background: var(--background-3);
  }
`

const IconContainer = styled.div`
  display: grid;
  padding-inline-end: 6px;
`

const Main = styled.div`
  display: flex;
  justify-content: space-between;
`

const ColumnLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const ColumnRight = styled(ColumnLeft)`
  align-items: flex-start;
`

const MarketCap = styled(ColumnLeft)`
  align-items: flex-start;

  border-inline-start: 1px solid var(--background-4);
  margin-inline-start: 8px;
  padding-inline-start: 8px;
`
